import moment from 'moment';
import Text from '@deprecated-ui/common/Text';
import { Divider } from 'antd';
import { formatNumber } from 'utils/number';
import If from 'global/ErrorHandlers/If';
import { BondTransactionActionEnum } from 'global/Securities/types/api/bond';
import { formatBondCurrency } from 'features/securities/withdrawal/utils';
import { useBondsModalStore } from '../../stores/useBondsModalStore';
import { useBondOrder } from '../../stores/useBondOrder';
import {
  BorderedContainer,
  Field,
  FieldSet,
  ModalBody,
  ModalContainer,
  ModalHeader,
} from '../../styled';
import ModalTitle from '../ModalTitle';
import BondProductDisplay from '../BondProductDisplay';
import { BOND_PRODUCT_MOCK } from '../../__mocks__/bonds.mock';

export default function ModalBondHistory() {
  const closeModal = useBondsModalStore((s) => s.closeModal);
  const { selected } = useBondOrder((s) => ({
    selected: s.selected,
    isLoading: s.isLoading,
  }));

  const productId = selected?.product?.id;

  const action = selected?.action || BondTransactionActionEnum.BUY;
  const actionLabel = {
    [BondTransactionActionEnum.BUY]: '',
    [BondTransactionActionEnum.SELL]: 'Sell',
    [BondTransactionActionEnum.UNSPECIFIED]: 'Unspecified',
  }[action];

  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle
          title={`${actionLabel} ${productId}`}
          onClose={closeModal}
          isCentered
        />
      </ModalHeader>
      <ModalBody
        css={`
          width: 502px;
        `}
      >
        <BorderedContainer>
          <BondProductDisplay product={BOND_PRODUCT_MOCK} />
        </BorderedContainer>
        <BorderedContainer>
          <FieldSet>
            <Field>
              <div>Date</div>
              <div>
                {moment(selected?.ordered_at).format('DD MMM YY, HH:mm:ss')}
              </div>
            </Field>
            <Field>
              <div>Unit</div>
              <div>{selected?.trade_unit}</div>
            </Field>
            <Field>
              <div>{actionLabel} Price (%)</div>
              <div>{formatNumber(selected?.trade_amount, true, '0,0.00')}%</div>
            </Field>
            <Field>
              <div>{actionLabel} Amount</div>
              <div>{formatBondCurrency(selected?.trade_amount)}</div>
            </Field>
            <Field>
              <div>Accrued Interest</div>
              <div>{formatBondCurrency(selected?.trade_amount)}</div>
            </Field>
            <If condition={action === BondTransactionActionEnum.BUY}>
              <Field>
                <div>Stamp Duty</div>
                <div>{formatBondCurrency(selected?.trade_amount)}</div>
              </Field>
              <Field>
                <div>Total Payment</div>
                <Text family="bold">
                  {formatBondCurrency(selected?.trade_amount)}
                </Text>
              </Field>
            </If>
            <If condition={action === BondTransactionActionEnum.SELL}>
              <Field>
                <div>Total Fee</div>
                <div>{formatBondCurrency(selected?.trade_amount)}</div>
              </Field>
              <Divider
                css={`
                  margin: 0;
                `}
              />
              <Field>
                <Text family="bold">Total Amount</Text>
                <Text family="bold">
                  {formatBondCurrency(selected?.trade_amount)}
                </Text>
              </Field>
              <Field>
                <Text family="bold">Realized Gain</Text>
                <Text family="bold">
                  {formatBondCurrency(selected?.trade_amount)}
                </Text>
              </Field>
            </If>
          </FieldSet>
        </BorderedContainer>
      </ModalBody>
    </ModalContainer>
  );
}
